import { Box, lighten } from "@mui/material";
import "swiper/css";
import "swiper/css/pagination";
import { GREY } from "@/config/mui/colorPalette";

type Props = {
  primaryColor: string;
  sliderId: string;
};

export default function SliderPagination({ primaryColor, sliderId }: Props) {
  return (
    <Box
      aria-label="Slider pagination"
      className={`custom-swiper-pagination-${sliderId}`}
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        "& .swiper-pagination-bullet": {
          backgroundColor: GREY[30],
          opacity: 1,
          margin: "0 6px !important",
          "&.swiper-pagination-bullet-active": {
            width: "24px",
            borderRadius: "8px",
            backgroundColor: lighten(primaryColor, 0.4),
            transition: "width 0.3s linear",
          },
        },
      }}
    />
  );
}
